import React, { useState, useEffect } from 'react';
import { FaUserEdit, FaLock, FaEnvelope, FaPhone, FaWeixin, FaWhatsapp, FaFacebook, FaInstagram } from 'react-icons/fa';
import api from '../api';

const EditUserModal = ({ isOpen, onClose, user, onUserUpdated }) => {
    const [formData, setFormData] = useState({
        username: '', name: '', email: '', phone: '', wechat: '', 
        whatsapp: '', facebook: '', instagram: '', password: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (user) {
            setFormData({
                username: user.username || '',
                name: user.name || '',
                email: user.contactInfo?.email || user.email || '',
                phone: user.contactInfo?.phone || '',
                wechat: user.contactInfo?.wechat || '',
                whatsapp: user.contactInfo?.whatsapp || '',
                facebook: user.contactInfo?.facebook || '',
                instagram: user.contactInfo?.instagram || '',
                password: ''
            });
        }
    }, [user]);

    if (!isOpen || !user) return null;
    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        const contacts = [formData.email, formData.phone, formData.wechat, formData.whatsapp, formData.facebook, formData.instagram];
        if (!contacts.some(c => c.trim() !== '')) {
            setError("At least one contact method must be filled.");
            return;
        }

        setLoading(true);
        try {
            const payload = {
                name: formData.name,
                username: formData.username,
                contactInfo: {
                    email: formData.email, phone: formData.phone, wechat: formData.wechat,
                    whatsapp: formData.whatsapp, facebook: formData.facebook, instagram: formData.instagram
                }
            };
            if (formData.password.trim()) payload.password = formData.password;

            await api.put(`/users/${user.id}`, payload);
            onUserUpdated(); onClose();
        } catch (err) {
            setError(err.response?.data?.error || "Failed to update user");
        } finally { setLoading(false); }
    };

    return (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden flex flex-col max-h-[90vh]">
                <div className="bg-orange-500 p-6 flex justify-between items-center text-white shrink-0">
                    <h3 className="text-xl font-bold flex items-center gap-2"><FaUserEdit/> Edit User</h3>
                    <button onClick={onClose} className="text-white text-2xl">&times;</button>
                </div>
                <div className="p-6 overflow-y-auto">
                    {error && <div className="mb-4 bg-red-100 text-red-700 p-3 text-sm rounded">{error}</div>}
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="grid grid-cols-2 gap-4">
                            <div><label className="text-xs font-bold text-gray-500">Username</label><input name="username" value={formData.username} onChange={handleChange} className="w-full border p-2 rounded bg-gray-50" /></div>
                            <div><label className="text-xs font-bold text-gray-500">Full Name</label><input name="name" value={formData.name} onChange={handleChange} className="w-full border p-2 rounded" /></div>
                        </div>
                        <div><label className="text-xs font-bold text-gray-500">New Password (Optional)</label><div className="relative"><FaLock className="absolute left-3 top-3 text-gray-400"/><input name="password" type="password" value={formData.password} onChange={handleChange} className="w-full border p-2 pl-10 rounded" placeholder="Leave blank to keep" /></div></div>

                        <div className="space-y-3 pt-2 border-t mt-2">
                            <p className="text-xs font-bold text-gray-400 uppercase">Contact Details</p>
                            <div className="relative"><FaEnvelope className="absolute left-3 top-3 text-gray-400"/><input name="email" value={formData.email} onChange={handleChange} className="w-full border p-2 pl-10 rounded text-sm" placeholder="Email" /></div>
                            <div className="grid grid-cols-2 gap-4">
                                <div className="relative"><FaPhone className="absolute left-3 top-3 text-gray-400"/><input name="phone" value={formData.phone} onChange={handleChange} className="w-full border p-2 pl-10 rounded text-sm" placeholder="Phone" /></div>
                                <div className="relative"><FaWeixin className="absolute left-3 top-3 text-gray-400"/><input name="wechat" value={formData.wechat} onChange={handleChange} className="w-full border p-2 pl-10 rounded text-sm" placeholder="WeChat" /></div>
                            </div>
                            <div className="grid grid-cols-3 gap-2">
                                <div className="relative"><FaWhatsapp className="absolute left-2 top-2.5 text-gray-400"/><input name="whatsapp" value={formData.whatsapp} onChange={handleChange} className="w-full border p-2 pl-8 rounded text-xs" placeholder="WhatsApp" /></div>
                                <div className="relative"><FaFacebook className="absolute left-2 top-2.5 text-gray-400"/><input name="facebook" value={formData.facebook} onChange={handleChange} className="w-full border p-2 pl-8 rounded text-xs" placeholder="Facebook" /></div>
                                <div className="relative"><FaInstagram className="absolute left-2 top-2.5 text-gray-400"/><input name="instagram" value={formData.instagram} onChange={handleChange} className="w-full border p-2 pl-8 rounded text-xs" placeholder="Instagram" /></div>
                            </div>
                        </div>
                        <button type="submit" disabled={loading} className="w-full bg-orange-600 text-white font-bold py-3 rounded-xl shadow mt-4">{loading ? 'Saving...' : 'Save Changes'}</button>
                    </form>
                </div>
            </div>
        </div>
    );
};
export default EditUserModal;